import { render, staticRenderFns } from "./IndexBedrag.vue?vue&type=template&id=4865b3ee"
import script from "./IndexBedrag.vue?vue&type=script&lang=js"
export * from "./IndexBedrag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports